import { isValidJson, valueCheckBox } from 'components/form/utilities'
import { updateSymbol, updateVisibility, useDataTemplate } from 'components/form_builder/features/data/dataSlice'
import { getPathsFromConditions } from 'lib/utilities/form/utilities'
import { isEmpty } from 'lodash'
import React, { useCallback, useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import SelectField from './SelectField'

const OptionItem = ({ type, name }) => {
  const renderValue = useCallback((type) => {
    switch (type) {
      case 'check':
        return <i className="fa-light fa-lg fa-square-check"></i>
      case 'mark':
        return <i className="fa-light fa-lg fa-square-xmark"></i>
      case 'square':
        return <i className="fa-solid fa-lg fa-square"></i>
      case 'circle':
        return <i className="fa-sharp fa-lg fa-solid fa-circle"></i>
      default:
        break
    }
  }, [])

  return (
    <div className="dome-d-flex dome-gap12 dome-align-center">
      {renderValue(type)}
      <span className="dome-p1 dome-color-dark-grey">{name}</span>
    </div>
  )
}

const OPTIONS = {
  check: { id: 'check', value: 'check', component: <OptionItem type="check" name="check" /> },
  mark: { id: 'mark', value: 'mark', component: <OptionItem type="mark" name="xmark" /> },
  square: { id: 'square', value: 'square', component: <OptionItem type="square" name="solid square" /> },
  circle: { id: 'circle', value: 'circle', component: <OptionItem type="circle" name="solid circle" /> },
}

export default function SymbolSelect({ component }) {
  const dispatch = useDispatch()
  const template = useDataTemplate(component.type, component.id)
  const [selectedOption, setSelectedOption] = useState(OPTIONS.check)

  useEffect(() => {
    setSelectedOption(OPTIONS[template.checkbox?.symbol ?? template.edit_on_page.mark])
  }, [template])

  const handleSelectChange = (option) => {
    dispatch(updateSymbol({ id: component.id, type: component.type, value: option.value }))
  }

  return (
    <div className="dome-full-width">
      <SelectField
        label="symbol"
        onSelect={handleSelectChange}
        options={Object.values(OPTIONS)}
        selectedOption={selectedOption}
      />
    </div>
  )
}
